import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import AdminHeader from './components/AdminHeader'
import AdminSidebar from './components/AdminSidebar'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Tours from './pages/Tours'
import TourForm from './pages/TourForm'
import Cruises from './pages/Cruises'
import CruiseForm from './pages/CruiseForm'
import Applications from './pages/Applications'
import ContractEditor from './pages/ContractEditor'

const AdminLayout = ({ children }) => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6' }}>
      <AdminHeader />
      <div style={{ display: 'flex' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: '2rem' }}>
          {children}
        </main>
      </div>
    </div>
  )
}

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="/" element={
        <ProtectedRoute>
          <AdminLayout>
            <Dashboard />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="tours" element={
        <ProtectedRoute>
          <AdminLayout>
            <Tours />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="tours/new" element={
        <ProtectedRoute>
          <AdminLayout>
            <TourForm />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="tours/:id" element={
        <ProtectedRoute>
          <AdminLayout>
            <TourForm />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="cruises" element={
        <ProtectedRoute>
          <AdminLayout>
            <Cruises />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="cruises/new" element={
        <ProtectedRoute>
          <AdminLayout>
            <CruiseForm />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="cruises/:id" element={
        <ProtectedRoute>
          <AdminLayout>
            <CruiseForm />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="applications" element={
        <ProtectedRoute>
          <AdminLayout>
            <Applications />
          </AdminLayout>
        </ProtectedRoute>
      } />
      <Route path="contract-editor" element={
        <ProtectedRoute>
          <ContractEditor />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  )
}

export default AdminRoutes